import { iconClose } from '@cube3/ui/src/icons/GeneralSVG';
import {
  ButtonFactory,
  ButtonFactoryConfig
} from '../../../../CommandBar/useButtonConfig';

export const DeleteContractButtonFactory = (
  onClick: () => void
): ButtonFactory => {
  const f = (config: ButtonFactoryConfig) => {
    const { canWriteContract } = config.privileges;

    const disabledReason = (() => {
      switch (true) {
        case !canWriteContract:
          return 'This account has no permission to delete contract';
        default:
          return undefined;
      }
    })();

    return {
      icon: iconClose,
      title: 'Delete',
      visible: true,
      disabled: !canWriteContract,
      disabledReason: disabledReason,
      onClick: onClick
    };
  };

  return {
    factory: f
  };
};
